module.exports = "/images/pt.svg";